(function () {
    'use strict';

    angular.module('dashboardModule')
        .controller('reading-list-view.controller', readingListViewController);

    readingListViewController.$inject = ['$stateParams', 'routeService', '$sce'];
    function readingListViewController($stateParams, routeService, $sce) {
        var vm = this;
        vm.initialize = initialize;
        vm.readingListId = $stateParams.readingListId;
        vm.readingListIframe = '';

        initialize();

        function initialize() {
            vm.readingListIframe = vm.readingListId ? $sce.trustAsResourceUrl(HandbookConfiguration.BackendURL + `dashboard/reading-list/${vm.readingListId}?hideTopBar=true`)
                                            : $sce.trustAsResourceUrl(HandbookConfiguration.BackendURL + 'dashboard/reading-list?hideTopBar=true');
        }
    };

})();